module.exports = __webpack_public_path__ + "img/app1.33fd6c12.png";